import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {User} from '@drl/core/auth/models/user.model';
import {UserStatus, userStatusTypesMap} from '@drl/core/enums/user-status.enum';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { genderMap } from '../models/gender.enum';

@Injectable()
export class CurrentUserAdapter implements IAdapter<User> {
  constructor(
    protected readonly translateSvc: IpsTranslateService,) {}

  adaptToModel(resp: any): User {
    const user: User = new User();
    const neutralIconPath = './assets/neutral-icon.svg';
    if (resp) {
      user.id = resp.id;
      user.firstName = resp.firstName;
      user.middleName = resp.middleName;
      user.lastName = resp.lastName;
      user.username = resp.username;
      user.email = resp.email;
      user.phone = resp.phone;
      user.roleId = resp.roleId;
      user.role = resp.role;
      user.permissions = resp.permissions;
      user.lastLogin = resp.lastLogin;
      user.status =
        resp.status &&
        userStatusTypesMap(this.translateSvc.translate)[parseInt(resp.status)];
      user.externalId = resp.externalId;
      user.gender =
        resp.gender &&
        genderMap(this.translateSvc.translate)[resp.gender.trim()];
      user.designation = resp.designation;
      user.photo = resp.photoUrl || neutralIconPath;
      user.pubnubToken = resp.pubnubToken;
      user.passwordExpiryTime = resp.passwordExpiryTime;
      user.bio = resp.bio;
      user.lang = resp.lang;
      user.experience = resp.experience;
      user.qualification = resp.qualification;
      user.lastOtp = resp.lastOtp;
      user.lastOtpDate = resp.lastOtpDate;
      user.isSelfOnb= resp.isSelfOnb;
      user.isAgeEntered = resp.isAgeEntered;
      user.isMinor  = resp.isMinor;
      user.relation = resp.relation;
      user.location = resp.location;
      user.relationLc=resp.relationLc;
    }
    return user;
  }
  adaptFromModel(data: User): any {
    const dataToSend = Object.assign({}, data, {
      status: data.status,
    });
    if (data.status !== UserStatus.ACTIVE || !data.lastLogin) {
      dataToSend.username = data.email;
    }

    return dataToSend;
  }
}
